<template>
    <div class="ms-notice">
        <div class="ms-notice-text" v-html="notice"></div>
    </div>
</template>

<script>
export default {
  name: "Notice",
  props: ['notice']
}
</script>



// WEBPACK FOOTER //
// src/components/Notice.vue